var React = require('react');

function Key (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 2a10 10 0 0 0-9.51 13.1l-7.2 7.2A1 1 0 0 0 3 23v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 .7-.3l1.2-1.19A10 10 0 1 0 20 2Zm0 18a7.96 7.96 0 0 1-2.96-.56 1 1 0 0 0-1.1.2L14.59 21H12a1 1 0 0 0-1 1v2H9a1 1 0 0 0-1 1v2H5v-3.59l7.35-7.35a1 1 0 0 0 .21-1.1A8 8 0 1 1 20 20Zm4-10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"}));
}

Key.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Key;

Key.default = Key;
